import React from "react";
import PropTypes from "prop-types";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import DragHandle from "@druva-apps/orion-icons/lib/RowdragndropGreyOutline";

const SortableGroup = ({ id, children, data }) => {
  const { listeners, setNodeRef, transform, transition, attributes } =
    useSortable({
      id
    });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition
  };

  return (
    <div className="oui-column-group" ref={setNodeRef} style={style}>
      <div className="oui-heading">
        <DragHandle
          className="oui-mr-2 oui-drag-handle"
          muted={false}
          {...listeners}
          {...attributes}
        />
        {data.title}
      </div>
      <div className="oui-group-body">{children}</div>
    </div>
  );
};

SortableGroup.propTypes = {
  id: PropTypes.string,
  data: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default SortableGroup;
